module.exports = __webpack_public_path__ + "img/teaching-8.522c1894.png";